module.exports = __webpack_public_path__ + "img/b9da7f2.jpg";